import React from "react";
import { Route, Routes } from "react-router-dom";
import { PinEntryPageFromOrder } from "./components/PinEntryPage/PinEntryPageFromOrder";
import { NotFound } from "./components/NotFound/NotFound";
import { Toaster } from "react-hot-toast";

export const App = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Routes>
        <Route
          path="/order-transfer/:orderId"
          element={<PinEntryPageFromOrder />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          style: {
            background: "#1f2937",
            color: "#fff",
            border: "1px solid #374151",
          },
        }}
      />
    </div>
  );
};
